import { ApolloQueryResult } from '@apollo/client'
import {
  RoleCompetenciesDocument,
  RoleCompetenciesQuery,
  RoleCompetencyFragment,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

type Return = [
  RoleCompetencyFragment[] | null | undefined,
  boolean,
  () => Promise<ApolloQueryResult<RoleCompetencyFragment[]>>
]

const joinRoleCompetencies = (data?: RoleCompetenciesQuery): RoleCompetencyFragment[] =>
  (data?.competencies.competenciesConnection.nodes || []).concat(
    data?.jobCatalog.role?.competencies || []
  )

export const useRoleCompetencies = (roleId: number, skip?: boolean): Return => {
  const { data, loading, networkActivity, refetch } = useQuery(RoleCompetenciesDocument, {
    variables: {
      roleId: roleId,
    },
    skip,
  })

  const refetchRoleCompetencies = async () => {
    const response = await refetch()

    return { ...response, data: joinRoleCompetencies(response.data) }
  }

  return [joinRoleCompetencies(data), loading || networkActivity, refetchRoleCompetencies]
}
